import { defineComponent as R, mergeModels as k, useModel as v, useTemplateRef as S, createElementBlock as A, openBlock as b, mergeProps as q, unref as o, createElementVNode as c, renderSlot as L, normalizeClass as B, createVNode as r, withCtx as d, createTextVNode as T, toDisplayString as $, createBlock as N, createCommentVNode as h, useId as M } from "vue";
import n from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/FileUpload/file-upload.js";
import { useOUIAProps as E } from "../helpers/ouia.js";
import z from "./InputGroup/InputGroup.vue2.js";
import g from "./InputGroup/InputGroupItem.vue2.js";
import O from "./TextInput.vue2.js";
import P from "./Button.vue2.js";
import Z from "./Textarea.vue2.js";
import j from "./Spinner.vue2.js";
import { useDropZone as G } from "@vueuse/core";
const J = ["accept", "name", "required"], le = /* @__PURE__ */ R({
  name: "PfFileUpload",
  __name: "FileUpload",
  props: /* @__PURE__ */ k({
    id: { default: () => M() },
    allowEditingUploadedText: { type: Boolean },
    ariaLabel: { default: "File upload" },
    browseButtonText: { default: "Browse..." },
    clearButtonText: { default: "Clear" },
    filenameAriaLabel: {},
    filenamePlaceholder: { default: "Drag a file here or browse to upload" },
    hideDefaultPreview: { type: Boolean },
    name: {},
    clearButtonDisabled: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    required: { type: Boolean },
    spinnerAriaValueText: {},
    type: { default: "text" },
    validated: { default: "default" },
    dragActive: { type: Boolean },
    textareaName: {},
    textareaPlaceholder: {},
    dataTypes: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    modelValue: { default: null },
    modelModifiers: {},
    filename: { default: null },
    filenameModifiers: {},
    loading: { type: Boolean, default: !1 },
    loadingModifiers: {}
  }),
  emits: /* @__PURE__ */ k(["browseButtonClick", "clearButtonClick", "textAreaBlur", "textAreaClick", "fileInputChange", "readStarted", "readFinished"], ["update:modelValue", "update:filename", "update:loading"]),
  setup(m, { emit: U }) {
    const t = m, D = E({ id: t.ouiaId, safe: t.ouiaSafe }), u = v(m, "modelValue"), s = v(m, "filename"), f = v(m, "loading"), p = U, F = S("filenameInputRef");
    G(() => {
      var e;
      return (e = F.value) == null ? void 0 : e.$el;
    }, {
      dataTypes: t.dataTypes,
      multiple: !1,
      async onDrop(e) {
        e != null && e.length && await y(e[0]);
      }
    });
    function I(e) {
      return new Promise((a, l) => {
        const i = new FileReader();
        i.onload = () => a(i.result), i.onerror = () => l(i.error), t.type === "text" ? i.readAsText(e) : t.type === "dataURL" ? i.readAsDataURL(e) : t.type === "arrayBuffer" ? i.readAsArrayBuffer(e) : l("unknown type");
      });
    }
    async function y(e) {
      if (p("fileInputChange", e), s.value = (e == null ? void 0 : e.name) ?? null, !e) {
        u.value = null;
        return;
      }
      if (t.type !== "text" && t.type !== "dataURL")
        return;
      p("readStarted", e), f.value = !0;
      let a = null;
      try {
        a = await I(e);
      } finally {
        f.value = !1, p("readFinished", e, a), u.value = a;
      }
    }
    function V(e) {
      p("clearButtonClick", e), y(null);
    }
    return (e, a) => (b(), A("div", q(o(D), {
      class: [o(n).fileUpload, {
        [o(n).modifiers.dragHover]: e.dragActive,
        [o(n).modifiers.loading]: f.value
      }]
    }), [
      c("div", {
        class: B(o(n).fileUploadFileSelect)
      }, [
        r(z, null, {
          default: d(() => [
            r(g, { fill: "" }, {
              default: d(() => [
                r(O, {
                  id: `${e.id}-filename`,
                  ref: "filenameInputRef",
                  "read-only-variant": "default",
                  disabled: e.disabled,
                  "auto-validate": !1,
                  name: e.name,
                  "aria-label": e.filenameAriaLabel ?? (s.value ? "Read only filename" : e.filenamePlaceholder),
                  placeholder: e.filenamePlaceholder,
                  "model-value": s.value,
                  "aria-describedby": `${e.id}-browse-button`
                }, null, 8, ["id", "disabled", "name", "aria-label", "placeholder", "model-value", "aria-describedby"])
              ]),
              _: 1
            }),
            r(g, null, {
              default: d(() => [
                r(P, {
                  id: `${e.id}-browse-button`,
                  style: { cursor: "pointer" },
                  component: "label",
                  variant: "control",
                  disabled: e.disabled,
                  onClick: a[1] || (a[1] = (l) => e.$emit("browseButtonClick", l))
                }, {
                  default: d(() => {
                    var l;
                    return [
                      c("input", {
                        type: "file",
                        accept: (l = t.dataTypes) == null ? void 0 : l.join(","),
                        name: e.name,
                        required: e.required,
                        style: { display: "none" },
                        onChange: a[0] || (a[0] = (i) => {
                          var C, w;
                          return y(((w = (C = i.target) == null ? void 0 : C.files) == null ? void 0 : w[0]) ?? null);
                        })
                      }, null, 40, J),
                      T(" " + $(e.browseButtonText), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["id", "disabled"])
              ]),
              _: 1
            }),
            r(g, null, {
              default: d(() => [
                r(P, {
                  variant: "control",
                  disabled: e.disabled || (e.clearButtonDisabled ?? (!s.value && !u.value)),
                  onClick: V
                }, {
                  default: d(() => [
                    T($(e.clearButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 2),
      c("div", {
        class: B(o(n).fileUploadFileDetails)
      }, [
        !e.hideDefaultPreview && e.type === "text" ? (b(), N(Z, {
          key: 0,
          id: e.id,
          disabled: e.disabled,
          required: e.required,
          readonly: e.readonly || !!s.value && !e.allowEditingUploadedText,
          "resize-orientation": "vertical",
          validated: e.validated,
          "aria-label": e.ariaLabel,
          "model-value": typeof u.value == "string" ? u.value : "",
          name: e.textareaName,
          placeholder: e.textareaPlaceholder,
          onClick: a[2] || (a[2] = (l) => e.$emit("textAreaClick", l)),
          onBlur: a[3] || (a[3] = (l) => e.$emit("textAreaBlur", l))
        }, null, 8, ["id", "disabled", "required", "readonly", "validated", "aria-label", "model-value", "name", "placeholder"])) : h("", !0),
        f.value ? (b(), A("div", {
          key: 1,
          class: B(o(n).fileUploadFileDetailsSpinner)
        }, [
          r(j, {
            size: "lg",
            "aria-valuetext": e.spinnerAriaValueText
          }, null, 8, ["aria-valuetext"])
        ], 2)) : h("", !0)
      ], 2),
      L(e.$slots, "default")
    ], 16));
  }
});
export {
  le as default
};
